export default {"src":"/_next/static/media/2.faf1b79f.svg","height":171,"width":305,"blurWidth":0,"blurHeight":0};